import { map } from "@utils/axios";
import { FIREBASE } from "./_constant";

export const pushToken = (params) => {
  console.log("pushToken", params);
  return map().put(FIREBASE.PUT, params);
};
